<template>
  <div>
    <CollectionDetails :params="$route.query"/>
  </div>
</template>
<script>
import CollectionDetails from './components/CollectionDetails.vue'

export default {
  components: {
    CollectionDetails,
  },
}
</script>
